import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { VoucherType } from 'src/features/voucherTypes/utils/types';
import { VoucherTypeFormSchemaValues } from 'src/features/voucherTypes/utils/formSchema';

const RESOURCE = '/discounts/voucher-type/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: VoucherTypeFormSchemaValues): Promise<VoucherType> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateVoucherType };
